import { createTheme } from '@material-ui/core/styles';

// Regenimo Biosciences theme. Selected per-org via org.config.themeOverride = "regenimo".
// Only visible to orgs whose themeOverride is "regenimo" (or that list it in availableThemes).
//
// Brand colors approximate the Regenimo logo's blue + green palette. Tune the
// hex values here (no code changes elsewhere needed) — the patient app picks
// these up automatically via theme.palette.

const theme = createTheme({
    actionButton: {
        backgroundColor: '#FFFFFF',
        disabledBackgroundColor: '#BBBBBB',
        disabledIconColor: '#999999'
    },
    baseline: {
        background1: '#DDDDDD',
        background2: '#CCCCCC'
    },
    palette: {
        type: 'light',
        iconColor: '#666666',
        backgroundColor: '#FAFAFA',
        primary: {
            main: '#2E86AB',                 // Regenimo blue
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#5DAB87',                 // Regenimo green
            contrastText: '#FFFFFF',
        },
        text: {
            primary: '#1A1A2E',
            secondary: '#4A4A5E',
            disabled: '#9090A0'
        }
    },
    // Per-route dashboard card colors (same shape as the existing `opn` theme).
    // DashboardView.js reads these with hardcoded fallbacks.
    dashboard: {
        conversation: { iconColor: '#FFFFFF', backgroundColor: '#2E86AB', textColor: '#FFFFFF' },
        callDr:       { iconColor: '#FFFFFF', backgroundColor: '#5DAB87', textColor: '#FFFFFF' },
        callOrg:      { iconColor: '#FFFFFF', backgroundColor: '#5DAB87', textColor: '#FFFFFF' },
        appointments: { iconColor: '#2E86AB', backgroundColor: '#E8F2F7', textColor: '#1A1A2E' }
    },
    overrides: {
        MuiDrawer: { paper: { backgroundColor: '#FFFFFF' } },
        MuiList:   { root: { backgroundColor: '#FFFFFF' } },
        MuiCssBaseline: {
            '@global': {
                html: { backgroundColor: '#FAFAFA' },
            },
        },
    },
});

export default theme;
